import React, { FC } from 'react';

import PropTypes, { Validator } from 'prop-types';

import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';

type Item = {
  title: string;
};

type ProjectListCategoryTitleProps = {
  item: Item;
};

const ProjectListCategoryTitle: FC<ProjectListCategoryTitleProps> = ({
  item,
}) => {
  return (
    <div
      css={[
        {
          padding: '16px 16px 0',
        },
      ]}
    >
      <h4
        css={[
          theme.typography.heading4,
          {
            color: theme.colors.charcoal700,
            paddingBottom: 5,
            margin: 0,
          },
        ]}
      >
        {item.title}
      </h4>
      <Divider />
    </div>
  );
};

ProjectListCategoryTitle.displayName = 'ProjectListCategoryTitle';

ProjectListCategoryTitle.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }) as Validator<Item>,
};

export default ProjectListCategoryTitle;
